import _ from 'lodash'
import type {CssValue} from '../../constants'
import type {DecoratedStyleProperty} from '../../../../../decorations/styleProperties/constants'
import {hasValidKeys} from '../utils/object'

const VALID_KEYS = new Set(['value'])

const deserializeStylePropertyValue = (rule: CssValue): DecoratedStyleProperty['value'] | undefined => {
    try {
        const parsedRule = JSON.parse(rule)
        if (_.isString(parsedRule) || _.isNumber(parsedRule)) {
            return rule
        }
    } catch {
        return rule
    }
}

const serialize = (val: any): CssValue | undefined => {
    if (!_.isPlainObject(val) || _.isEmpty(val) || !hasValidKeys(val, VALID_KEYS)) {
        return undefined
    }

    const {value} = val

    if (!_.isString(value)) {
        return undefined
    }

    return value
}

const deserialize = (rule: CssValue): DecoratedStyleProperty | undefined => {
    const value = deserializeStylePropertyValue(rule)
    if (value === undefined) {
        return undefined
    }

    return {value}
}

export default {
    serialize,
    deserialize
}
